export const REQUEST_CREATEBET_START = 'REQUEST_CREATEBET_START'
export const REQUEST_CREATEBET_SUCCESS = 'REQUEST_CREATEBET_SUCCESS'
export const REQUEST_CREATEBET_FAIL = 'REQUEST_CREATEBET_FAIL'
export const CLEAR_BET_ERRORS = 'CLEAR_BET_ERRORS'
export const CHECKOUT_ON_BET_SUCCESS = 'CHECKOUT_ON_BET_SUCCESS'
export const CHECKOUT_ON_BET_REJECTED = 'CHECKOUT_ON_BET_REJECTED'
export const CHECKOUT_CLOSE_MODAL = 'CHECKOUT_CLOSE_MODAL'